import CommonIntroductionBase from "./common/CommonIntroductionBase";

const Documentation = () => {
  return (
    <CommonIntroductionBase
      slide="解説、企画、マニュアル等作成"
      collectionName="documentation"
      postTitle="解説、企画、マニュアル等作成"
      targetItems={[
        "order",
        "title",
        "content",
        "linkUrl",
        "youtubeUrl",
        "image",
      ]}
      enableMarkdown
    />
  );
};

export default Documentation;
